const translations = {
  en: {
    depositUsing: 'Deposit using e-Check',
    currency: 'Currency',
    amount: 'Amount',
    depositLimits: 'Deposit Limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    accountType: 'Account Type',
    personalChecking: 'Personal Checking',
    personalSavings: 'Personal Savings',
    commercialChecking: 'Commercial Checking',
    routingNumber: 'Routing Number',
    routingNumberPlaceholder: 'RoutingNumber',
    accountNumber: 'AccountNumber',
    bankName: 'Bank Name',
    bankNamePlaceholder: 'BankName',
    firstName: 'First Name',
    firstNamePlaceholder: 'Firstname',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Lastname',
    city: 'City',
    address: 'Address',
    address2: 'Address 2',
    address2Placeholder: 'Address2',
    country: 'Country',
    stateProv: 'State / Prov',
    zip: 'Zip',
    zipCode: 'ZipCode',
    phone: 'Phone',
    email: 'Email',
    description: 'Description',
    back: 'BACK',
    deposit: 'DEPOSIT',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    errorGettingCustomerInfo: 'Error getting customer info: ',
  },
  es: {
    depositUsing: 'Depositar usando e-Check',
    currency: 'Moneda',
    amount: 'Monto',
    depositLimits: 'Límites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    accountType: 'Tipo de Cuenta',
    personalChecking: 'Cuenta Corriente Personal',
    personalSavings: 'Cuenta de Ahorros Personal',
    commercialChecking: 'Cuenta Corriente Comercial',
    routingNumber: 'Número de Ruta',
    routingNumberPlaceholder: 'Número de Ruta',
    accountNumber: 'Número de Cuenta',
    bankName: 'Nombre del Banco',
    bankNamePlaceholder: 'Nombre del Banco',
    firstName: 'Nombre',
    firstNamePlaceholder: 'Nombre',
    lastName: 'Apellido',
    lastNamePlaceholder: 'Apellido',
    city: 'Ciudad',
    address: 'Dirección',
    address2: 'Dirección 2',
    address2Placeholder: 'Dirección 2',
    country: 'País',
    stateProv: 'Estado / Provincia',
    zip: 'Código Postal',
    zipCode: 'Código Postal',
    phone: 'Teléfono',
    email: 'Correo Electrónico',
    description: 'Descripción',
    back: 'ATRÁS',
    deposit: 'DEPOSITAR',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    errorGettingCustomerInfo: 'Error al obtener información del cliente: ',
  },
  pt: {
    depositUsing: 'Depositar usando e-Check',
    currency: 'Moeda',
    amount: 'Valor',
    depositLimits: 'Limites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    accountType: 'Tipo de Conta',
    personalChecking: 'Conta Corrente Pessoal',
    personalSavings: 'Conta Poupança Pessoal',
    commercialChecking: 'Conta Corrente Comercial',
    routingNumber: 'Número de Roteamento',
    routingNumberPlaceholder: 'Número de Roteamento',
    accountNumber: 'Número de Conta',
    bankName: 'Nome do Banco',
    bankNamePlaceholder: 'Nome do Banco',
    firstName: 'Nome',
    firstNamePlaceholder: 'Nome',
    lastName: 'Sobrenome',
    lastNamePlaceholder: 'Sobrenome',
    city: 'Cidade',
    address: 'Endereço',
    address2: 'Endereço 2',
    address2Placeholder: 'Endereço 2',
    country: 'País',
    stateProv: 'Estado / Província',
    zip: 'CEP',
    zipCode: 'CEP',
    phone: 'Telefone',
    email: 'E-mail',
    description: 'Descrição',
    back: 'VOLTAR',
    deposit: 'DEPOSITAR',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
  },
}

export default translations
